import api from "@/lib/axios";

export interface MentorOpenBalance {
  mentorId: string;
  mentorName: string;
  mentorEmail: string;
  openBalanceUsd: number;
  availablePaymentsCount: number;
}

export interface MentorPaymentItem {
  paymentId: string;
  grossAmount: number;
  mentorFees: number;
  mentorFeesUsd: number;
  currency: string;
  customerEmail: string | null;
  paidAt: string;
  stripeChargeId: string | null;
}

export interface CreatePayoutDto {
  mentorId: string;
  startDate: string;
  endDate: string;
  expectedAmountUsd: number;
}

export interface CreatedPayout {
  payoutId: string;
  mentorId: string;
  amountUsd: number;
  paymentsCount: number;
  startDate: string;
  endDate: string;
  stripePayoutId: string | null;
}

export interface PayoutHistoryItem {
  payoutId: string;
  mentorId: string;
  mentorName: string;
  mentorEmail: string;
  amountUsd: number;
  paymentsCount: number;
  startDate: string;
  endDate: string;
  createdAt: string;
}

export interface MentorPayoutItem {
  payoutId: string;
  amountUsd: number;
  paymentsCount: number;
  startDate: string;
  endDate: string;
  createdAt: string;
}

export enum MentorPayoutsKeys {
  GET_OPEN_BALANCES = "get-open-balances",
  GET_MENTOR_PAYMENTS = "get-mentor-payments",
  GET_PAYOUT_HISTORY = "get-payout-history",
  GET_MY_PAYOUTS = "get-my-payouts",
}

export const getOpenBalances = async (): Promise<MentorOpenBalance[]> => {
  const response = await api.get<MentorOpenBalance[]>(
    "/mentor-payouts/open-balances",
  );
  return response.data;
};

export const getMentorPayments = async (
  mentorId: string,
): Promise<MentorPaymentItem[]> => {
  const response = await api.get<MentorPaymentItem[]>(
    `/mentor-payouts/${mentorId}/payments`,
  );
  return response.data;
};

export const createPayout = async (
  dto: CreatePayoutDto,
): Promise<CreatedPayout> => {
  const response = await api.post<CreatedPayout>("/mentor-payouts", dto);
  return response.data;
};

export const getPayoutHistory = async (): Promise<PayoutHistoryItem[]> => {
  const response = await api.get<PayoutHistoryItem[]>(
    "/mentor-payouts/history",
  );
  return response.data;
};

export const getMyPayouts = async (): Promise<MentorPayoutItem[]> => {
  const response = await api.get<MentorPayoutItem[]>(
    "/mentor-payouts/my-payouts",
  );
  return response.data;
};

export interface RecipientOnboardingResult {
  recipientAccountId: string;
  onboardingUrl: string;
}

export const startPayoutOnboarding =
  async (): Promise<RecipientOnboardingResult> => {
    const response = await api.post<RecipientOnboardingResult>(
      "/mentor-payouts/start-onboarding",
    );
    return response.data;
  };

export const refreshOnboardingLink = async (): Promise<{
  onboardingUrl: string;
}> => {
  const response = await api.post<{ onboardingUrl: string }>(
    "/mentor-payouts/refresh-onboarding-link",
  );
  return response.data;
};
